import React, { useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';
import Icon from '../Icon';
import clsx from 'clsx';

interface CollapsibleAttributes {
  label?: string | JSX.Element;
  className?: string;
  transitionDuration?: string;
  onStateChange?: Function;
  isOpen?: boolean;
  hideBorder?: boolean;
  children?: any;
}

export default ({
  children,
  label,
  className = '',
  onStateChange: externalStateChange,
  isOpen: externalIsOpen,
  hideBorder,
}: CollapsibleAttributes) => {
  const [isOpen, setIsOpen] = useState<boolean>(externalIsOpen ?? false);

  const onStateChange = (open: boolean) => {
    externalStateChange && externalStateChange(open);
    setIsOpen(open);
  };

  useEffect(() => {
    setIsOpen(externalIsOpen ?? false);
  }, [externalIsOpen]);

  return (
    <div
      className={`collapsible [&_.ReactCollapse--content]:!pb-0 [&_ul>li]:border-b [&_ul>li_a]:pl-[1.75rem]  [&_ul>li_a]:text-md ${
        className ?? ''
      } ${hideBorder ? 'border-b-0 border-t-0' : ''}`}
    >
      <label className="border-b border-gray-300 !pb-0 !pt-0 text-md !font-[400] [&_>a]:flex-1 ">
        {label}
        <div
          className="flex h-10 w-10 items-center justify-center border-l border-gray-300"
          onClick={() => onStateChange(!isOpen)}
        >
          <Icon
            className={clsx(
              'h-5 w-5 duration-200',
              isOpen ? 'rotate-180' : 'rotate-0'
            )}
            name="caret-down"
          />
        </div>
      </label>
      <div className="collapsible__content">
        <Collapse isOpened={isOpen}>{children}</Collapse>
      </div>
    </div>
  );
};
